"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _react = require('react');

var _deriveSender = require('shared/services/createNew/deriveSender');














const useDerivedSender = ({
  recipients,
  senderKey,
  senderOrgKey,
  myPhoneTeams,
  myActiveOrgKeys,
  applySender,
  clearSender,
}) => {
  const [manuallyChosen, setManuallyChosen] = _react.useState.call(void 0, false)
  const [userClearGeneration, setUserClearGeneration] = _react.useState.call(void 0, 0)
  const previouslyHadRecipientsRef = _react.useRef.call(void 0, false)
  const filterDrivenEmptyRef = _react.useRef.call(void 0, false)

  const manualSender = _react.useMemo.call(void 0, 
    () => manuallyChosen && senderKey && senderOrgKey
      ? { senderKey, orgKey: senderOrgKey }
      : null,
    [manuallyChosen, senderKey, senderOrgKey],
  )
  const result = _react.useMemo.call(void 0, 
    () => _deriveSender.deriveSender.call(void 0, {
      recipients,
      myPhoneTeams,
      myActiveOrgKeys,
      manualSender,
    }),
    [recipients, myPhoneTeams, myActiveOrgKeys, manualSender],
  )

  _react.useEffect.call(void 0, () => {
    if (result.type === 'derived') applySender(result.senderKey)
    else if (result.type === 'ambiguous') clearSender()
  }, [result, applySender, clearSender])

  _react.useEffect.call(void 0, () => {
    const hasRecipients = recipients.length > 0
    if (previouslyHadRecipientsRef.current && !hasRecipients) {
      if (filterDrivenEmptyRef.current) {
        filterDrivenEmptyRef.current = false
      } else {
        setManuallyChosen(false)
        setUserClearGeneration(generation => generation + 1)
      }
    }
    previouslyHadRecipientsRef.current = hasRecipients
  }, [recipients])

  const markManual = _react.useCallback.call(void 0, () => setManuallyChosen(true), [])
  const resetStickiness = _react.useCallback.call(void 0, () => setManuallyChosen(false), [])
  const markNextEmptyAsFilterDriven = _react.useCallback.call(void 0, () => {
    filterDrivenEmptyRef.current = true
  }, [])
  const pinnedOrgKey = _deriveSender.derivePinnedOrgKey.call(void 0, recipients, manualSender)

  return {
    result,
    ambiguous: result.type === 'ambiguous' ? result : null,
    pinnedOrgKey,
    manuallyChosen,
    userClearGeneration,
    markManual,
    resetStickiness,
    markNextEmptyAsFilterDriven,
  }
}

exports. default = useDerivedSender
